export default __webpack_public_path__ + "static/media/e-ppt-picturemark-l.3fde599a.svg";